import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MenuSelectEvent } from '@progress/kendo-angular-menu';
import { NotificationService } from '@progress/kendo-angular-notification';
import { PopupRef } from '@progress/kendo-angular-popup';
import { find, get, trim } from 'lodash';
import { AdminService } from 'src/app/modules/administration/services/admin.service';
import { ASSESSMENT_INFO } from 'src/app/modules/evaluations/assessment/constants/assessment-routes';
import { AssessmentService } from 'src/app/modules/evaluations/assessment/services/assessment.services';
import { iepSections } from 'src/app/modules/iep/iep-document/constants/iep-sections';
import { IepSubmitEligibilityRequest } from 'src/app/modules/iep/iep-document/models/iep-eligibilty-models/iep-submit-eligibility.model';
import { IEPService } from 'src/app/modules/iep/iep-document/services/iep.services';
import { NursingReferralService } from 'src/app/modules/nursing-referral/services/nursing-referral.service';
import { PwnType } from 'src/app/modules/pwn/shared/enums/pwn-type';
import { ReferralType } from 'src/app/modules/referrals/interfaces/referrals.model';
import { RoutesConstantService } from 'src/app/services/routes-constant.service';
import { AbstractComponent } from 'src/app/shared/components/abstract-component';
import { MeetingType } from 'src/app/shared/enums/meeting-type';
import { MeetingRole } from 'src/app/shared/interfaces/meeting-role';
import { User } from 'src/app/shared/models/user';
import { AuthStore } from 'src/app/stores/auth.store';
import {
  ActionsResponse,
  StageActions,
} from '../../../modules/dashboard/interface/actions-response';
import { DashboardService } from '../../../modules/dashboard/services/dashboard.service';
import { Constants } from '../../constants/constants';
import {
  dialogAnimationDuration,
  dialogTimer,
} from '../../constants/dialog-specs';

import { PWN_INFO } from 'src/app/modules/pwn/constants/pwn-routes';
import {
  CREATE_ANNUAL_IEP_MEETING,
  EDIT_PARENT_OT_CHECKLIST,
  EDIT_PT_PARENT_CHECKLIST,
  EDIT_PT_TEACHER_CHECKLIST,
  EDIT_TEACHER_OT_CHECKLIST,
  INDEX_NOT_FOUND,
  LABEL_SCHOOL_SOCIAL_WORKERS,
  NAVIGATION_DELAYS,
  PHYSICAL_EXAMINATION,
  RECONVENE_IEP_MEETING,
  RESCHEDULE_IEP_MEETING,
  SHARE_PERSONALLY_IDENTIFIABLE_INFORMATION,
  TITLE_SCHOOL_SOCIAL_WORKERS,
  VIEW_NOTICE_OF_IEP_MEETING,
  VIEW_PARENT_OT_CHECKLIST,
  VIEW_PT_PARENT_CHECKLIST,
  VIEW_PT_TEACHER_CHECKLIST,
  VIEW_TEACHER_OT_CHECKLIST,
} from '../../constants/grid-actions';
import { NOTIFICATION_MESSAGES } from '../../constants/notification-messages';
import { IepType } from '../../enums/iep-types';
import { MenuAction } from '../../enums/menu-items';
import { IReferenceData } from '../../interfaces/form/reference-data.model';
import { ISedmsFormOutput } from '../../interfaces/form/sedms-form-output.model';

@Component({
  selector: 'app-custom-actions',
  templateUrl: './custom-actions.component.html',
  styleUrls: ['./custom-actions.component.scss'],
  standalone: false,
})
export class CustomActionsComponent extends AbstractComponent {
  @Input() actionsList: ActionsResponse;
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Input() studentDetails: any;
  @Input() evalActions: StageActions;
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Input() evalRowDetails: any;
  @Output() refreshGrid: EventEmitter<void> = new EventEmitter<void>();
  @Output() scheduleMeetingDialog: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() cancelMeetingDialog: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() closeRequestForReevaluationDialog: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() requestExtensionDialog: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() scheduleMeetingAssessmentDialog: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() caseClosingEventsDialog: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() captureFirstAttendDate: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Output() reAssign: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() uploadDialog: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() extensionDialog: EventEmitter<string> = new EventEmitter<string>();
  @Output() meetingType: EventEmitter<MeetingType> =
    new EventEmitter<MeetingType>();
  @Output() meetingSk: EventEmitter<string> = new EventEmitter<string>();
  @Output() isViewMode: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() actionText: EventEmitter<string> = new EventEmitter<string>();
  @Output() meetingRoster: EventEmitter<MeetingRole[]> = new EventEmitter<
    MeetingRole[]
  >();
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Output() pwn: EventEmitter<any> = new EventEmitter<any>();
  @Output() isReAssign: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() isReSchedule: EventEmitter<boolean> = new EventEmitter<boolean>();
  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  @Output() selectedEvalRowDetails: EventEmitter<any> = new EventEmitter<any>();

  @Output() amendIEPDialog: EventEmitter<string> = new EventEmitter<string>();
  @Output() annualIEPDialog: EventEmitter<string> = new EventEmitter<string>();
  @Output() removeFromMDEWorklistDialog: EventEmitter<string> =
    new EventEmitter<string>();
  popupRef: PopupRef;
  @Output() twelveMonthDialog: EventEmitter<string> =
    new EventEmitter<string>();
  readonly sharePersonallyIdentifiableInformation: number = 1038;
  readonly otherAssessmentType: number = 48;
  meetingTypeENUM: typeof MeetingType = MeetingType;
  referralSk: number;
  iepSk: string;
  evaluationSk: string;
  nycId: string;
  user: User;
  caseStage: string;
  showDialog: boolean = true;
  teacherSk: string;
  otparentSk: string;
  loadSpinner: boolean;
  providerSk: any;

  constructor(
    private router: Router,
    private routesConstantService: RoutesConstantService,
    private authStore: AuthStore,
    private notificationService: NotificationService,
    private iepService: IEPService<IepSubmitEligibilityRequest>,
    private dashboardService: DashboardService,
    private assessmentService: AssessmentService<ISedmsFormOutput>,
    private adminService: AdminService,
    private nursingReferralService: NursingReferralService
  ) {
    super();
    this.user = this.authStore.UserInfo;
  }

  openCaseClosingEventsDialog(): void {
    this.caseClosingEventsDialog.emit(true);
  }

  closeCaseClosingEventsDialog(): void {
    this.caseClosingEventsDialog.emit(false);
    this.refreshGrid.emit();
  }

  openCaptureFirstAttendDateDialog(): void {
    this.captureFirstAttendDate.emit(true);
  }

  closeCaptureFirstAttendDateDialog(): void {
    this.captureFirstAttendDate.emit(false);
  }

  openReassignDialog(): void {
    this.reAssign.emit(true);
  }

  closeReassignDialog(): void {
    this.reAssign.emit(false);
  }
  onSelect(event: MenuSelectEvent, stageName: string): void {
    let actionObj, actionSk: string;
    this.nycId = this.studentDetails?.nycid;
    this.referralSk = this.studentDetails.referralSK;
    this.iepSk = this.actionsList?.iep?.stageSk;
    this.evaluationSk = this.actionsList?.assessments?.stageSk;
    this.providerSk = this.studentDetails?.providerSK;
    this.caseStage = this.studentDetails?.caseStage;
    this.actionText.emit(event.item.text);
    this.selectedEvalRowDetails.emit(this.evalRowDetails);
    let iepType: number;
    switch (stageName) {
      // REFERRALS
      case 'Referral': {
        actionObj = this.actionsList.referrals.stageDetails.find(
          (item: StageActions) =>
            item.actionName.find((text: string) => text === event.item.text)
        );
        this.isViewMode.emit(event.item.text?.split(' ')[0] === 'View');
        actionSk = actionObj.actionSk;

        const pwnType = actionObj.actionType;

        switch (event.item.text) {
          case 'View':
            if (
              actionObj.actionType === ReferralType.RequestForReevaluation ||
              actionObj.actionType ===
              ReferralType.RequestForAdditionalReevaluation
            ) {
              this.router.navigate([
                this.routesConstantService.routes.referrals +
                this.referralSk +
                '/' +
                this.nycId +
                '/view/request-for-reevaluation',
              ]);
            } else {
              this.router.navigate(
                [this.routesConstantService.routes.viewReferralsRequestPage],
                { queryParams: { Id: this.referralSk, nycId: this.nycId } }
              );
            }
            break;
          case 'Add Referral':
            this.router.navigate([
              this.routesConstantService.routes.newReferralsRequestPage,
              this.nycId,
            ]);
            break;
          case 'Edit':
            if (
              actionObj.actionType === ReferralType.RequestForReevaluation ||
              actionObj.actionType ===
              ReferralType.RequestForAdditionalReevaluation
            ) {
              this.router.navigate([
                this.routesConstantService.routes.referrals +
                this.referralSk +
                '/' +
                this.nycId +
                '/edit/request-for-reevaluation',
              ]);
            } else {
              this.router.navigate(
                [this.routesConstantService.routes.newReferralsRequestPage],
                { queryParams: { Id: this.referralSk, nycId: this.nycId } }
              );
            }
            break;
          case 'Review':
            if (
              actionObj.actionType === ReferralType.RequestForReevaluation ||
              actionObj.actionType ===
              ReferralType.RequestForAdditionalReevaluation
            ) {
              this.router.navigate([
                this.routesConstantService.routes.referrals +
                this.referralSk +
                '/' +
                this.nycId +
                '/edit/review-request-for-reevaluation',
              ]);
            } else {
              this.router.navigate(
                [this.routesConstantService.routes.reviewReferralsRequestPage],
                { queryParams: { Id: this.referralSk } }
              );
            }
            break;
          case 'Send PWN':
            // Commented this code for redirecting to common PWN
            // !actionObj.actionType || actionObj.actionType == OutreachType.NoticeOfIR || actionObj.actionType == OutreachType.Refusal || actionObj.actionType == OutreachType.PreSchool ?
            //   this.router.navigate([this.routesConstantService.routes.referralsManagePwnPage], { queryParams: { Id: this.referralSk, viewMode: false } }) :
            this.router.navigate([
              this.routesConstantService.routes.referrals +
              this.referralSk +
              '/' +
              this.nycId +
              '/add/pwn/' +
              this.getPwnUrl(pwnType),
            ]);
            break;
          case 'View PWN':
            // !actionObj.actionType || actionObj.actionType == OutreachType.NoticeOfIR || actionObj.actionType == OutreachType.Refusal || actionObj.actionType == OutreachType.PreSchool ?
            //   this.router.navigate([this.routesConstantService.routes.referralsManagePwnPage], { queryParams: { Id: this.referralSk, viewMode: true } }) :
            this.router.navigate([
              this.routesConstantService.routes.referrals +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              actionSk +
              '/view/pwn/' +
              this.getPwnUrl(pwnType),
            ]);
            break;
          case 'Edit PWN':
            this.router.navigate([
              this.routesConstantService.routes.referrals +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              actionSk +
              '/edit/pwn/' +
              this.getPwnUrl(pwnType),
            ]);
            break;
          case 'Edit Reeval PWN':
            this.router.navigate([
              this.routesConstantService.routes.referrals +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              actionSk +
              '/edit/pwn/' +
              this.getPwnUrl(pwnType),
            ]);
            break;
          case 'Schedule SHM':
          case 'Schedule Social History Meeting':
            this.meetingType.emit(this.meetingTypeENUM.SHM);
            this.meetingRoster.emit([
              {
                label: 'SCHOOL SOCIAL WORKERS (MANDATED SERVICES)',
                title: 'SCHOOL SOCIAL WORKERS (MANDATED SERVICES)',
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            this.showDialog = false;
            break;
          case 'Reschedule SHM':
          case 'Reschedule Social History Meeting':
            this.meetingType.emit(this.meetingTypeENUM.SHM);
            this.meetingSk.emit(
              this.actionsList.referrals.stageDetails.find(
                (item: StageActions) =>
                  item.actionName.find(
                    (name: string) =>
                      name === 'Reschedule Social History Meeting'
                  )
              )?.actionSk
            );
            this.meetingRoster.emit([
              {
                label: 'SCHOOL SOCIAL WORKERS (MANDATED SERVICES)',
                title: 'SCHOOL SOCIAL WORKERS (MANDATED SERVICES)',
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            this.showDialog = false;
            break;
          case 'View SHM':
          case 'View Social History Meeting':
            this.meetingType.emit(this.meetingTypeENUM.SHM);
            this.meetingSk.emit(
              this.actionsList.referrals.stageDetails.find(
                (item: StageActions) =>
                  item.actionName.find(
                    (name: string) => name === 'View Social History Meeting'
                  )
              )?.actionSk
            );
            this.meetingRoster.emit([
              {
                label: 'SCHOOL SOCIAL WORKERS (MANDATED SERVICES)',
                title: 'SCHOOL SOCIAL WORKERS (MANDATED SERVICES)',
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            this.showDialog = false;
            break;
          case 'Schedule Gen Ed Intervention Meeting':
            this.meetingType.emit(this.meetingTypeENUM.GenEd);
            this.meetingRoster.emit([
              {
                label: 'PRINCIPAL',
                title: 'PRINCIPAL',
                isRequired: true,
                isSticky: true,
                members: [],
              },
              {
                label: 'TEACHER',
                title: 'TEACHER',
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            break;
          case 'Reschedule Gen Ed Intervention Meeting':
            this.meetingType.emit(this.meetingTypeENUM.GenEd);
            this.meetingSk.emit(
              this.actionsList.referrals.stageDetails.find(
                (item: StageActions) =>
                  item.actionName.find(
                    (name: string) =>
                      name === 'Reschedule Gen Ed Intervention Meeting'
                  )
              )?.actionSk
            );
            this.meetingRoster.emit([
              {
                label: 'PRINCIPAL',
                title: 'PRINCIPAL',
                isRequired: true,
                isSticky: true,
                members: [],
              },
              {
                label: 'TEACHER',
                title: 'TEACHER',
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            break;
          case 'Send Parent-Principal Written Agreement':
            this.router.navigate([
              this.routesConstantService.routes.referrals +
              this.referralSk +
              '/' +
              this.nycId +
              '/add/pwn/' +
              this.getPwnUrl(
                PwnType.WithdrawalInitialReferralFromSpecialEducationProcess
              ),
            ]);
            break;
          case 'Edit Parent-Principal Written Agreement':
              this.router.navigate([
              this.routesConstantService.routes.referrals +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              actionSk +
              '/edit/pwn/' +
              this.getPwnUrl(
                PwnType.WithdrawalInitialReferralFromSpecialEducationProcess
              ),
            ]);
            break;
          case 'View Parent-Principal Written Agreement':
            this.router.navigate([
              this.routesConstantService.routes.referrals +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              actionSk +
              '/view/pwn/' +
              this.getPwnUrl(
                PwnType.WithdrawalInitialReferralFromSpecialEducationProcess
              ),
            ]);
            break;
          case 'Withdraw':
            this.router.navigate(
              [this.routesConstantService.routes.referralsWithdrawPage],
              { queryParams: { Id: this.referralSk } }
            );
            break;
          case 'Create Request to Share Personally Identifiable Information':
            this.router.navigate([
              this.routesConstantService.routes
                .PersonallyIdentifiableInformation +
              this.nycId +
              '/' +
              this.sharePersonallyIdentifiableInformation +
              '/' +
              this.referralSk +
              '/' +
              'add',
            ]);
            break;
          case 'Edit Request to Share Personally Identifiable Information':
            this.router.navigate([
              this.routesConstantService.routes
                .PersonallyIdentifiableInformation +
              this.nycId +
              '/' +
              this.sharePersonallyIdentifiableInformation +
              '/' +
              this.referralSk +
              '/' +
              'edit',
            ]);
            break;
          case 'View Request to Share Personally Identifiable Information': {
            const index: number =
              this.actionsList.student.stageDetails.findIndex(
                (obj: StageActions) => obj.actionName.includes(event.item.text)
              );
            let sk: any = this.sharePersonallyIdentifiableInformation;
            if (index > -1) {
              sk = this.actionsList.student.stageDetails[index].actionSk;
            }
            this.router.navigate([
              this.routesConstantService.routes
                .PersonallyIdentifiableInformation +
              this.nycId +
              '/' +
              sk +
              '/' +
              this.referralSk +
              '/' +
              'view',
            ]);
            break;
          }
          case 'Close Request':
            this.openShowCloseRequestForReevaluationDialog(
              actionObj.actionType
            );
            break;
        }
        break;
      }
      case 'IEP': {
        actionObj = this.actionsList.iep.stageDetails.find(
          (item: StageActions) =>
            item.actionName.find((text: string) => text === event.item.text)
        );
        actionSk = actionObj.actionSk;
        iepType = actionObj.actionType;
        const declassificationId: string =
          this.actionsList.iep.stageDetails.find((item: StageActions) =>
            item.actionName.find(
              (name: string) => name === 'View Declassification'
            )
          )?.actionSk;
        const ineligibilitySk: string = this.actionsList.iep.stageDetails.find(
          (item: StageActions) =>
            item.actionName.find(
              (name: string) => name === 'View InEligibility'
            )
        )?.actionSk;
        this.meetingSk.emit(
          this.actionsList.iep.stageDetails.find((item: StageActions) =>
            item.actionName.find(
              (name: string) => name === 'View Notice of IEP Meeting'
            )
          )?.actionSk
        );
        this.isViewMode.emit(event.item.text?.split(' ')[0] === 'View');
        switch (event.item.text) {
          case 'Create IEP Document':
          case 'Create IEP': {
            const typeOfMeetingId: IReferenceData =
              Constants.IEP_MEETINGTYPE.find(
                (item: IReferenceData) => item.description === this.caseStage
              );
            const eligibilityRequestdata: IepSubmitEligibilityRequest =
              new IepSubmitEligibilityRequest({
                referralSK: this.referralSk,
                lastModuser: this.user?.username,
                typeOfMeeting:
                  typeOfMeetingId ?? Constants.IEP_MEETINGTYPE[0].id,
                iepMeetingType: typeOfMeetingId,
                dbn: this.studentDetails?.dbn,
                dob: this.studentDetails?.dob,
                studentSK: this.studentDetails?.studentSK
              });
            this.iepService
              .submit(eligibilityRequestdata, iepSections.eligibilty)
              .subscribe((data) => {
                if (data) {
                  this.router.navigate([
                    this.routesConstantService.routes.addiepdocument +
                    this?.nycId +
                    '/' +
                    data?.value?.iepFormSK +
                    '/edit/eligibility',
                  ]);
                  this.closePopup();
                }
              });
            break;
          }
          case 'Amend IEP':
            this.amendIEPDialog.emit(this.iepSk);
            break;
          case 'Edit IEP Document':
            if (iepType === IepType.CSP) {
              this.router.navigate([
                this.routesConstantService.routes.addiepdocument +
                this.nycId +
                '/' +
                this.iepSk +
                '/edit/Recommended-program-and-services-CSP',
              ]);
            } else {
              this.router.navigate([
                this.routesConstantService.routes.addiepdocument +
                this.nycId +
                '/' +
                this.iepSk +
                '/edit/eligibility',
              ]);
            }
            break;
          case 'Create 12 Month School Year Consent Form (Add)':
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              'twelve-month' +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/add',
            ]);
            break;
          case 'View 12 Month School Year Consent Form':
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              'twelve-month' +
              '/' +
              this.nycId +
              '/' +
              actionSk +
              '/' +
              this.iepSk +
              '/view',
            ]);
            break;
          case 'Create Compensatory Services':
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              'Compensatory-programs-services' +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/add',
            ]);
            break;
          case 'Edit Compensatory Services':
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              'Compensatory-programs-services' +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/' +
              actionSk +
              '/edit',
            ]);
            break;
          case 'View Compensatory Services':
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              'Compensatory-programs-services' +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/' +
              actionSk +
              '/view',
            ]);
            break;
          //Consent for Services/ Deferred Placement
          case 'Create Consent for Services/ Deferred Placement':
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/services-deferred-placement',
            ]);
            break;
          case 'Edit Consent for Services/ Deferred Placement':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/services-deferred-placement',
            ]);
            break;
          case 'View Consent for Services/ Deferred Placement':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/services-deferred-placement',
            ]);
            break;
          case 'View IEP Document':
            if (iepType === IepType.CSP) {
              this.router.navigate([
                this.routesConstantService.routes.addiepdocument +
                this.nycId +
                '/' +
                this.iepSk +
                '/view/Recommended-program-and-services-CSP',
              ]);
            } else {
              this.router.navigate([
                this.routesConstantService.routes.addiepdocument +
                this.nycId +
                '/' +
                this.iepSk +
                '/view/eligibility',
              ]);
            }
            break;
          case 'Create Assurance Checklist':
            this.router.navigate([
              this.routesConstantService.routes.assuranceChecklist +
              this.nycId +
              '/' +
              this.iepSk +
              '/add',
            ]);
            break;
          case 'Edit Assurance Checklist':
            this.router.navigate([
              this.routesConstantService.routes.assuranceChecklist +
              this.nycId +
              '/' +
              this.iepSk +
              '/edit',
            ]);
            break;
          case 'View Assurance Checklist':
            this.router.navigate([
              this.routesConstantService.routes.assuranceChecklist +
              this.nycId +
              '/' +
              this.iepSk +
              '/view',
            ]);
            break;
          case 'Review Assurance Checklist':
            this.router.navigate([
              this.routesConstantService.routes.assuranceChecklist +
              this.nycId +
              '/' +
              this.iepSk +
              '/review',
            ]);
            break;

          case MenuAction.CreateLreForm:
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              'lre' +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/add',
            ]);
            break;
          case MenuAction.EditLreForm:
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              'lre' +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/edit',
            ]);
            break;
          case MenuAction.ViewLreForm:
            this.router.navigate([
              this.routesConstantService.routes.addiepdocument +
              'lre' +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/view',
            ]);
            break;

          case MenuAction.CreateIneligibilityDocument:
            this.router.navigate([
              this.routesConstantService.routes.ineligibilityDocuments +
              '/' +
              this.nycId +
              '/' +
              this.studentDetails?.studentSk +
              '/edit',
            ]);
            break;
          case MenuAction.ViewIneligibilityDocument:
          case MenuAction.ViewIneligibility:
            this.router.navigate([
              this.routesConstantService.routes.ineligibilityDocuments +
              '/' +
              this.nycId +
              '/' +
              actionSk +
              '/' +
              this.iepSk +
              '/view',
            ]);
            break;
          case MenuAction.CreateWaiverOfIepMeeting:
            this.router.navigate([
              this.routesConstantService.routes.waiverofIepMeeting +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/add',
            ]);
            break;
          case MenuAction.ViewWaiverOfIepMeeting:
            this.isViewMode.emit(true);
            this.router.navigate([
              this.routesConstantService.routes.waiverofIepMeeting +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/' +
              actionSk +
              '/view',
            ]);
            break;
          case MenuAction.ViewDeclassification:
            this.router.navigate([
              this.routesConstantService.routes.declassification +
              this.nycId +
              '/' +
              actionSk +
              '/' +
              this.iepSk +
              '/view',
            ]);
            break;
          case MenuAction.CreateDeclassification:
            this.router.navigate([
              this.routesConstantService.routes.declassification +
              this.nycId +
              '/' +
              this.iepSk +
              '/edit',
            ]);
            break;
          case MenuAction.EditDeclassification:
            this.router.navigate([
              this.routesConstantService.routes.declassification +
              this.nycId +
              '/' +
              actionSk +
              '/' +
              this.iepSk +
              '/edit',
            ]);
            break;
          case MenuAction.ScheduleIepMeeting:
            this.meetingType.emit(this.meetingTypeENUM.IEP);
            this.meetingRoster.emit([
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            this.showDialog = false;
            break;
          case MenuAction.ViewNoticeOfIEPMeeting:
            this.meetingType.emit(this.meetingTypeENUM.IEP);
            this.isViewMode.emit(true);
            this.meetingSk.emit(
              this.actionsList.iep.stageDetails.find((item: StageActions) =>
                item.actionName.find(
                  (name: string) => name === VIEW_NOTICE_OF_IEP_MEETING
                )
              )?.actionSk
            );
            this.meetingRoster.emit([
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            this.showDialog = false;
            break;
          case MenuAction.ViewIEPMeeting:
            this.meetingType.emit(this.meetingTypeENUM.IEP);
            this.isViewMode.emit(true);
            this.meetingRoster.emit([
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.RescheduleIepMeeting:
            this.meetingType.emit(this.meetingTypeENUM.IEP);
            this.meetingSk.emit(
              this.actionsList.iep.stageDetails.find((item: StageActions) =>
                item.actionName.find(
                  (name: string) => name === RESCHEDULE_IEP_MEETING
                )
              )?.actionSk
            );
            this.meetingRoster.emit([
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            this.showDialog = false;
            break;
          case MenuAction.ReconveneIEPMeeting:
            this.meetingType.emit(this.meetingTypeENUM.IEPReconvene);
            this.meetingSk.emit(
              this.actionsList.iep.stageDetails.find((item: StageActions) =>
                item.actionName.find(
                  (name: string) => name === RECONVENE_IEP_MEETING
                )
              )?.actionSk
            );
            this.meetingRoster.emit([
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            this.showDialog = false;
            break;
          case MenuAction.CreateAnnualIEPMeeting:
            this.meetingType.emit(this.meetingTypeENUM.AnnualReview);
            this.meetingSk.emit(
              this.actionsList.iep.stageDetails.find((item: StageActions) =>
                item.actionName.find(
                  (name: string) => name === CREATE_ANNUAL_IEP_MEETING
                )
              )?.actionSk
            );
            this.meetingRoster.emit([
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            this.showDialog = false;
            break;
          case 'Create Nursing Referral':
            this.router.navigate([
              `./nursing-referral/add/${this.nycId}/${actionSk}`,
            ]);
            break;
          case 'View Nursing Referral':
            this.router.navigate([
              `./nursing-referral/view/${this.nycId}/${actionSk}`,
            ]);
            break;
          case 'Delete Nursing Referral':
            this.nursingReferralService
              .removeNursingReferral(actionSk)
              .subscribe((data) => {
                if (data) {
                  this.notificationService.show({
                    content: 'Submitted Successfully',
                    cssClass: 'notification-success',
                    hideAfter: dialogTimer,
                    position: { horizontal: 'center', vertical: 'top' },
                    animation: {
                      type: 'slide',
                      duration: dialogAnimationDuration,
                    },
                    type: { style: 'success', icon: true },
                  });
                  this.dashboardService.reloadDashboardSubject$.next(true);
                }
              });
            break;
          case 'Create 12 Month School Year Consent Form':
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/tweleve-month-school-year',
            ]);
            break;
          case MenuAction.EditTwelveMonthSchoolYearConsentForm:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/tweleve-month-school-year',
            ]);
            break;
          case MenuAction.ViewTwelveMonthSchoolYearConsentForm:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/tweleve-month-school-year',
            ]);
            break;
          case MenuAction.SendPwnNoticeOfRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepSk +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/add/pwn/' +
              this.getPwnUrl(iepType),
            ]);
            break;
          case MenuAction.ViewPwnNoticeOfRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepSk +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/' +
              actionSk +
              '/view/pwn/' +
              this.getPwnUrl(iepType),
            ]);
            break;
          case MenuAction.EditPwnNoticeOfRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepSk +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/' +
              actionSk +
              '/edit/pwn/' +
              this.getPwnUrl(iepType),
            ]);
            break;
          case MenuAction.ViewDeclassificationPwnRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${declassificationId}/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/view/pwn/declassification',
            ]);
            break;
          case MenuAction.ViewIneligibilityPwnRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${ineligibilitySk}/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/view/pwn/initial-eligibility-recommendation-ineligible',
            ]);
            break;
          case MenuAction.EditDeclassificationPwnRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${declassificationId}/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/edit/pwn/declassification',
            ]);
            break;
          case MenuAction.EditIneligibilityPwnRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${ineligibilitySk}/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/edit/pwn/initial-eligibility-recommendation-ineligible',
            ]);
            break;
          case MenuAction.CaptureFirstAttendDate:
            this.openCaptureFirstAttendDateDialog();
            break;
          case 'Annual Review IEP':
            this.annualIEPDialog.emit(this.iepSk);
            break;
          case MenuAction.CreateProgressReport:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/progress-reports/${this.nycId}/${this.studentDetails?.studentSK}` +
              '/edit',
            ]);
            break;
          case MenuAction.EditProgressReport:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/progress-reports/${this.nycId}/${this.studentDetails?.studentSK}` +
              '/edit',
            ]);
            break;
          case 'Send PWN (Notice of Recommendation) Parentally Placed':
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepSk +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/add/pwn/' +
              this.getPwnUrl(iepType),
            ]);
            break;
          case 'View PWN (Notice of Recommendation) Parentally Placed':
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepSk +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/' +
              actionSk +
              '/view/pwn/' +
              this.getPwnUrl(iepType),
            ]);
            break;
          case 'Edit PWN (Notice of Recommendation) Parentally Placed':
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepSk +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/' +
              actionSk +
              '/edit/pwn/' +
              this.getPwnUrl(iepType),
            ]);
            break;
          case 'Send PWN (Declassification)':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/pwn/declassification',
            ]);
            break;
          case MenuAction.EditPWNDeclassification:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/edit/pwn/declassification',
            ]);
            break;
          case MenuAction.ViewPWNDeclassification:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/view/pwn/declassification',
            ]);
            break;
          case MenuAction.SendPWNIneligibility:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/pwn/initial-eligibility-recommendation-ineligible',
            ]);
            break;
          case MenuAction.EditPWNIneligibility:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/edit/pwn/initial-eligibility-recommendation-ineligible',
            ]);
            break;
          case MenuAction.ViewPWNIneligibility:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/view/pwn/initial-eligibility-recommendation-ineligible',
            ]);
            break;
          case MenuAction.CreateConsentInitialProvisionServices:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/initial-provision-services',
            ]);
            break;
          case MenuAction.EditConsentInitialProvisionServices:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/initial-provision-services',
            ]);
            break;
          case MenuAction.ViewConsentInitialProvisionServices:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/initial-provision-services',
            ]);
            break;
          //  Initial Provision of Services/Parentally Placed
          case 'Create Consent for Initial Provision of Services/Parentally Placed':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/initial-provision-services-parentally-placed',
            ]);
            break;
          case MenuAction.EditConsentInitialProvisionServicesParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/initial-provision-services-parentally-placed',
            ]);
            break;
          case MenuAction.ViewConsentInitialProvisionServicesParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/initial-provision-services-parentally-placed',
            ]);
            break;
        }
        break;
      }
      case 'KIP':
        actionObj = this.actionsList.kip.stageDetails.find(
          (item: StageActions) =>
            item.actionName.find((text: string) => text === event.item.text)
        );
        this.isViewMode.emit(event.item.text?.split(' ')[0] === 'View');
        actionSk = actionObj.actionSk;
        switch (event.item.text) {
          case 'Create Child Outcome Summary':
            this.router.navigate([
              this.routesConstantService.routes.kip +
              '/' +
              this.nycId +
              '/add/child-outcomes-summary',
            ]);
            break;
          case 'Edit Child Outcome Summary':
            this.router.navigate([
              this.routesConstantService.routes.kip +
              '/' +
              this.nycId +
              '/edit/child-outcomes-summary',
            ]);
            break;
          case 'View Child Outcome Summary':
            this.router.navigate([
              this.routesConstantService.routes.kip +
              '/' +
              this.nycId +
              '/view/child-outcomes-summary',
            ]);
            break;
        }
        break;

      case 'Placement': {
        this.iepSk = this.actionsList.placements?.stageSk;
        actionObj = this.actionsList.placements.stageDetails.find(
          (item: StageActions) =>
            item.actionName.find((text: string) => text === event.item.text)
        );
        actionSk = actionObj.actionSk;
        iepType = actionObj.actionType;

        switch (event.item.text) {
          // Initial Provision of Services
          // case 'Create Consent for Initial Provision of Services':
          //   this.router.navigate([this.routesConstantService.routes.placement + `/${this.nycId}/${this.iepSk}/${iepType}` + "/add/consent/initial-provision-services"]);
          //   break;
          // case 'Edit Consent for Initial Provision of Services':
          //   this.router.navigate([this.routesConstantService.routes.placement + `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` + "/edit/consent/initial-provision-services"]);
          //   break;
          // case 'View Consent for Initial Provision of Services':
          //   this.router.navigate([this.routesConstantService.routes.placement + `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` + "/view/consent/initial-provision-services"]);
          //   break;

          case 'Capture First Attend Date':
            this.openCaptureFirstAttendDateDialog();
            break;

          //  Services/ Deferred Placement
          case MenuAction.CreateConsentServicesDeferredPlacement:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/services-deferred-placement',
            ]);
            break;
          case MenuAction.EditConsentServicesDeferredPlacement:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/services-deferred-placement',
            ]);
            break;
          case MenuAction.ViewConsentServicesDeferredPlacement:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/services-deferred-placement',
            ]);
            break;

          //  DEP-1
          case MenuAction.CreateConsentDep1:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/dep',
            ]);
            break;
          case MenuAction.EditConsentDep1:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/dep',
            ]);
            break;
          case MenuAction.ViewConsentDep1:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/dep',
            ]);
            break;

          // Parent Notice of Intent/Parentally Placed
          case MenuAction.CreateConsentParentNoticeIntentParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/parent-notice-of-intent',
            ]);
            break;
          case MenuAction.EditConsentParentNoticeIntentParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/parent-notice-of-intent',
            ]);
            break;
          case MenuAction.ViewConsentParentNoticeIntentParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/parent-notice-of-intent',
            ]);
            break;
          //PWN (notice of Recommendation) Parentally Placed
          case 'Send PWN (Notice of Recommendation) Parentally Placed':
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepSk +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/add/pwn/' +
              this.getPwnUrl(iepType),
            ]);
            break;
          case 'Edit PWN (Notice of Recommendation) Parentally Placed':
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepSk +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/' +
              actionSk +
              '/edit/pwn/' +
              this.getPwnUrl(iepType),
            ]);
            break;
          case 'View PWN (Notice of Recommendation) Parentally Placed':
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              '/' +
              this.iepSk +
              '/' +
              this.nycId +
              '/' +
              this.iepSk +
              '/' +
              actionSk +
              '/view/pwn/' +
              this.getPwnUrl(iepType),
            ]);
            break;
          //  Share Information/Parentally Placed
          case MenuAction.CreateConsentShareInformationParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/initial-provision-services-parentally-placed',
            ]);
            break;
          case MenuAction.EditConsentShareInformationParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/initial-provision-services-parentally-placed',
            ]);
            break;
          case MenuAction.ViewConsentShareInformationParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/initial-provision-services-parentally-placed',
            ]);
            break;
          case MenuAction.CreateRequestToShareInformationParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/request-to-share-information',
            ]);
            break;
          case MenuAction.EditRequestToShareInformationParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/request-to-share-information',
            ]);
            break;
          case MenuAction.ViewRequestToShareInformationParentallyPlaced:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/request-to-share-information',
            ]);
            break;

          //  Extended School Year Parent Survey
          case MenuAction.CreateConsentExtendedSchoolYearParentSurvey:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/ESY-survey',
            ]);
            break;
          case MenuAction.EditConsentExtendedSchoolYearParentSurvey:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/ESY-survey',
            ]);
            break;
          case MenuAction.ViewConsentExtendedSchoolYearParentSurvey:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/ESY-survey',
            ]);
            break;

          //  C7P
          case MenuAction.CreateConsentC7P:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/final-notice-of-recommendation',
            ]);
            break;
          case MenuAction.EditConsentC7P:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/final-notice-of-recommendation',
            ]);
            break;
          case MenuAction.ViewConsentC7P:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/final-notice-of-recommendation',
            ]);
            break;

          //  Outreaches
          case MenuAction.CreateSchoolPlacementRequest:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/outreach/school-placement-request',
            ]);
            break;
          case MenuAction.EditSchoolPlacementRequest:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/edit/outreach/school-placement-request',
            ]);
            break;
          case MenuAction.ViewSchoolPlacementRequest:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/view/outreach/school-placement-request',
            ]);
            break;
          case MenuAction.CreateStudentExitSummary:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/outreach/student-exit-summary',
            ]);
            break;
          case MenuAction.EditStudentExitSummary:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/edit/outreach/student-exit-summary',
            ]);
            break;
          case MenuAction.ViewStudentExitSummary:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/view/outreach/student-exit-summary',
            ]);
            break;
          case MenuAction.CreateAuthorizationToAttendLetter:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/outreach/authorization-to-attend-letter',
            ]);
            break;
          case MenuAction.EditAuthorizationToAttendLetter:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/edit/outreach/authorization-to-attend-letter',
            ]);
            break;
          case MenuAction.ViewAuthorizationToAttendLetter:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/view/outreach/authorization-to-attend-letter',
            ]);
            break;
          case MenuAction.CreateP1Package:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/outreach/p1-package',
            ]);
            break;
          case MenuAction.EditP1Package:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/edit/outreach/p1-package',
            ]);
            break;
          case MenuAction.ViewP1Package:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/view/outreach/p1-package',
            ]);
            break;
          case 'Create P-2 Response Letter':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/outreach/p2-package',
            ]);
            break;
          case 'Edit P-2 Response Letter':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/edit/outreach/p2-package',
            ]);
            break;
          case 'View P-2 Response Letter':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/view/outreach/p2-package',
            ]);
            break;
          case 'Create Authorization of the IEP - No Change':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/outreach/ar1p-no-change',
            ]);
            break;
          case MenuAction.EditAuthorizationIepNoChange:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/edit/outreach/ar1p-no-change',
            ]);
            break;
          case MenuAction.ViewAuthorizationIepNoChange:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/view/outreach/ar1p-no-change',
            ]);
            break;
          case MenuAction.CreateAuthorizationIepChange:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/outreach/ar2p-change',
            ]);
            break;
          case MenuAction.EditAuthorizationIepChange:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/edit/outreach/ar2p-change',
            ]);
            break;
          case MenuAction.ViewAuthorizationIepChange:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/view/outreach/ar2p-change',
            ]);
            break;
          case MenuAction.CreateFinalNoticeRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/outreach/c8p-final-notice-of-recommendation',
            ]);
            break;
          case MenuAction.EditFinalNoticeRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/edit/outreach/c8p-final-notice-of-recommendation',
            ]);
            break;
          case MenuAction.ViewFinalNoticeRecommendation:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/view/outreach/c8p-final-notice-of-recommendation',
            ]);
            break;
          case MenuAction.CreateParentWithdrawalOfConsent:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/parent-withdrawal-of-consent',
            ]);
            break;
          case MenuAction.EditParentWithdrawalOfConsent:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/parent-withdrawal-of-consent',
            ]);
            break;
          case MenuAction.ViewParentWithdrawalOfConsent:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/parent-withdrawal-of-consent',
            ]);
            break;
          case MenuAction.CreateNoticeOfTermination:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${iepType}` +
              '/add/consent/notice-of-termination',
            ]);
            break;
          case MenuAction.EditNoticeOfTermination:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/edit/consent/notice-of-termination',
            ]);
            break;
          case MenuAction.ViewNoticeOfTermination:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${actionSk}/${this.nycId}/${this.iepSk}/${iepType}` +
              '/view/consent/notice-of-termination',
            ]);
            break;

          case MenuAction.CreatePriorNoticePlacementWithdrawal:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/pwn/withdrawal-initial-referral-special-education-process',
            ]);
            break;
          case MenuAction.EditPriorNoticePlacementWithdrawal:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/edit/pwn/withdrawal-initial-referral-special-education-process',
            ]);
            break;
          case MenuAction.ViewPriorNoticePlacementWithdrawal:
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/view/pwn/withdrawal-initial-referral-special-education-process',
            ]);
            break;
          case 'Launch 10-Month Placement Finder':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}` +
              '/add/placement-finder',
            ]);
            break;
          case 'Launch 10-Month School Age Placement Finder':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}` +
              '/add/placement-finder-schoolage',
            ]);
            break;
          case 'Launch Summer Placement Finder':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}` +
              '/add/summer-placement-finder',
            ]);
            break;
          case 'Launch Summer School Age Placement Finder':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}` +
              '/add/summer-placement-finder-schoolage',
            ]);
            break;
          case 'Initiate State Approved NPS Referral Process':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}` +
              '/state-approved-nps-referral',
            ]);
            break;
          case 'Review State Approved NPS Referral Process':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/state-approved-nps-referral/review',
            ]);
            break;
          case 'View State Approved NPS Referral Process':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/cover-letter/cbst-review',
            ]);
            break;

          case 'Review CSE Cover Letter':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/cover-letter/review',
            ]);
            break;
          case 'View CSE Cover Letter':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.nycId}/${this.iepSk}/${actionSk}` +
              '/cover-letter/view',
            ]);
            break;
        }
        break;
      }
      case MenuAction.Evaluation:
        actionObj = this.actionsList.assessments.stageDetails.find(
          (item: StageActions) =>
            item.actionName.find((text: string) => text === event.item.text)
        );
        actionSk = actionObj.actionSk;
        switch (event.item.text) {
          case MenuAction.EditSocialHistoryPackage:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/edit/shp',
            ]);
            break;
          case MenuAction.ViewSocialHistoryPackage:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/view/shp',
            ]);
            break;
          case MenuAction.AssessmentPlanning:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.nycId +
              '/edit/assessment-planning',
            ]);
            break;
          case MenuAction.SendPwnAdditionalAssessments:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.nycId +
              '/add/pwn/request-additional-assessments',
            ]);
            break;
          case MenuAction.EditPwnAdditionalAssessments:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              actionSk +
              '/edit/pwn/request-additional-assessments',
            ]);
            break;
          case MenuAction.ReviewPwnAdditionalAssessments:
            this.router.navigate(
              [
                this.routesConstantService.routes.evaluations +
                this.referralSk +
                '/' +
                this.nycId +
                '/' +
                actionSk +
                '/edit/pwn/request-additional-assessments',
              ],
              {
                state: { type: Constants.review },
              }
            );
            break;
          case MenuAction.ViewPwnAdditionalAssessments:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.nycId +
              '/' +
              actionSk +
              '/view/pwn/request-additional-assessments',
            ]);
            break;
          case MenuAction.CreatePreschoolSummary:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              '/' +
              this.nycId +
              '/' +
              this.referralSk +
              '/edit/preschool-summary',
            ]);
            break;
          case MenuAction.ViewPreschoolSummary:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              '/' +
              this.nycId +
              '/' +
              this.referralSk +
              '/' +
              actionSk +
              '/view/preschool-summary',
            ]);
            break;
          case MenuAction.EditPreschoolSummary:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              '/' +
              this.nycId +
              '/' +
              this.referralSk +
              '/' +
              actionSk +
              '/edit/preschool-summary',
            ]);
            break;
          case MenuAction.RescheduleShm:
          case MenuAction.RescheduleSocialHistoryMeeting:
            this.meetingType.emit(this.meetingTypeENUM.SHM);
            this.meetingRoster.emit([
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.CancelMeetings:
            this.openShowCancelMeetingDialog();
            break;
          case MenuAction.ScheduleMeeting:
            this.meetingType.emit(this.meetingTypeENUM.EVL);
            this.meetingRoster.emit([
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.RescheduleMeeting:
            this.meetingType.emit(this.meetingTypeENUM.EVL);
            this.meetingRoster.emit([
              {
                label: LABEL_SCHOOL_SOCIAL_WORKERS,
                title: TITLE_SCHOOL_SOCIAL_WORKERS,
                isRequired: true,
                isSticky: true,
                members: [],
              },
            ]);
            this.openScheduleMeetingDialog();
            break;
          case MenuAction.CloseRequest:
            this.openShowCloseRequestForReevaluationDialog(
              actionObj.actionType
            );
            break;
          case MenuAction.CreateFinalNoticeWithdrawalEval:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              `${this.referralSk}/${this.nycId}` +
              '/add/outreach/final-notice-of-withdrawal',
            ]);
            break;
          case MenuAction.EditFinalNoticeWithdrawalEval:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              `${this.referralSk}/${this.nycId}/${actionSk}` +
              '/edit/outreach/final-notice-of-withdrawal',
            ]);
            break;
          case MenuAction.ViewFinalNoticeWithdrawalEval:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              `${this.referralSk}/${this.nycId}/${actionSk}` +
              '/view/outreach/final-notice-of-withdrawal',
            ]);
            break;
          case 'Remove from MDE Worklist':
            this.removeFromMDEWorklistDialog.emit(
              this.studentDetails?.studentSK
            );
            break;
        }
        break;
      case MenuAction.EvaluationsNested:
        switch (event.item.text) {
          case MenuAction.ViewAssessment:
            if (this.evalRowDetails.evaluationName === PHYSICAL_EXAMINATION)
              this.router.navigate([
                this.routesConstantService.routes.evaluations +
                this.referralSk +
                '/' +
                this.evalRowDetails.evaluationSk +
                '/' +
                this.nycId +
                '/view/physical-examination',
              ]);
            else if (
              this.evalRowDetails?.evaluationType === this.otherAssessmentType
            ) {
              this.router.navigate([
                this.routesConstantService.routes.evaluations +
                this.referralSk +
                '/' +
                this.evalRowDetails.evaluationSk +
                '/' +
                this.nycId +
                '/view/other-assessment',
              ]);
            } else {
              const routeSuffix: string = this.evaluationDataRoute(
                this.evalRowDetails
              );
              if (routeSuffix) {
                this.router.navigate([
                  this.routesConstantService.routes.evaluations +
                  this.referralSk +
                  '/' +
                  this.evalRowDetails.evaluationSk +
                  '/' +
                  this.nycId +
                  '/viewassessment/' +
                  this.evaluationDataRoute(this.evalRowDetails),
                ]);
              }
            }
            break;
          case MenuAction.Edit:
            if (this.evalRowDetails.evaluationName === PHYSICAL_EXAMINATION)
              this.router.navigate([
                this.routesConstantService.routes.evaluations +
                this.referralSk +
                '/' +
                this.evalRowDetails.evaluationSk +
                '/' +
                this.nycId +
                '/edit/physical-examination',
              ]);
            else if (
              this.evalRowDetails?.evaluationType === this.otherAssessmentType
            ) {
              this.router.navigate([
                this.routesConstantService.routes.evaluations +
                this.referralSk +
                '/' +
                this.evalRowDetails.evaluationSk +
                '/' +
                this.nycId +
                '/edit/other-assessment',
              ]);
            } else {
              const routeSuffix: string = this.evaluationDataRoute(
                this.evalRowDetails
              );
              if (routeSuffix) {
                this.router.navigate([
                  this.routesConstantService.routes.evaluations +
                  this.referralSk +
                  '/' +
                  this.evalRowDetails.evaluationSk +
                  '/' +
                  this.nycId +
                  '/edit/' +
                  this.evaluationDataRoute(this.evalRowDetails),
                ]);
              }
            }
            break;
          case MenuAction.RequestExtension:
          case MenuAction.ReviewRequestExtension:
            this.extensionDialog.emit(event.item.text);
            break;

          case MenuAction.EditTeacherOTChecklist: {
            const otteacheraction: StageActions[] =
              this.evalActions.subActionDetails;
            this.teacherSk = otteacheraction.find((item: StageActions) =>
              item.actionName.find(
                (type: string) => type === EDIT_TEACHER_OT_CHECKLIST
              )
            )?.actionSk;
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.teacherSk +
              '/' +
              this.nycId +
              '/edit/occupational-therapy-teacher-checklist',
            ]);
            break;
          }
          case MenuAction.ViewTeacherOTChecklist: {
            const viewsubaction: StageActions[] =
              this.evalActions.subActionDetails;
            this.teacherSk = viewsubaction.find((item: StageActions) =>
              item.actionName.find(
                (type: string) => type === VIEW_TEACHER_OT_CHECKLIST
              )
            )?.actionSk;
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.teacherSk +
              '/' +
              this.nycId +
              '/viewassessment/occupational-therapy-teacher-checklist',
            ]);
            break;
          }
          case MenuAction.EditPTTeacherChecklist: {
            const ptteacheraction: StageActions[] =
              this.evalActions.subActionDetails;
            this.teacherSk = ptteacheraction.find((item: StageActions) =>
              item.actionName.find(
                (type: string) => type === EDIT_PT_TEACHER_CHECKLIST
              )
            )?.actionSk;
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.teacherSk +
              '/' +
              this.nycId +
              '/edit/physical-therapy-teacher-checklist',
            ]);
            break;
          }
          case MenuAction.ViewPTTeacherChecklist: {
            const viewptteacheraction: StageActions[] =
              this.evalActions.subActionDetails;
            this.teacherSk = viewptteacheraction.find((item: StageActions) =>
              item.actionName.find(
                (type: string) => type === VIEW_PT_TEACHER_CHECKLIST
              )
            )?.actionSk;
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.teacherSk +
              '/' +
              this.nycId +
              '/viewassessment/physical-therapy-teacher-checklist',
            ]);
            break;
          }
          case MenuAction.EditParentOTChecklist: {
            const otparentaction: StageActions[] =
              this.evalActions.subActionDetails;
            this.otparentSk = otparentaction.find((item: StageActions) =>
              item.actionName.find(
                (type: string) => type === EDIT_PARENT_OT_CHECKLIST
              )
            )?.actionSk;
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.otparentSk +
              '/' +
              this.nycId +
              '/edit/occupational-therapy-parent-checklist',
            ]);
            break;
          }
          case MenuAction.ViewParentOTChecklist: {
            const viewotparentaction: StageActions[] =
              this.evalActions.subActionDetails;
            this.otparentSk = viewotparentaction.find((item: StageActions) =>
              item.actionName.find(
                (type: string) => type === VIEW_PARENT_OT_CHECKLIST
              )
            )?.actionSk;
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.otparentSk +
              '/' +
              this.nycId +
              '/viewassessment/occupational-therapy-parent-checklist',
            ]);
            break;
          }
          case MenuAction.EditPTParentChecklist: {
            const ptparentaction: StageActions[] =
              this.evalActions.subActionDetails;
            this.otparentSk = ptparentaction.find((item: StageActions) =>
              item.actionName.find(
                (type: string) => type === EDIT_PT_PARENT_CHECKLIST
              )
            )?.actionSk;
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.otparentSk +
              '/' +
              this.nycId +
              '/edit/physical-therapy-parent-checklist',
            ]);
            break;
          }
          case MenuAction.ViewPTParentChecklist: {
            const viewptparentaction: StageActions[] =
              this.evalActions.subActionDetails;
            this.otparentSk = viewptparentaction.find((item: StageActions) =>
              item.actionName.find(
                (type: string) => type === VIEW_PT_PARENT_CHECKLIST
              )
            )?.actionSk;
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.otparentSk +
              '/' +
              this.nycId +
              '/viewassessment/physical-therapy-parent-checklist',
            ]);
            break;
          }
          case MenuAction.CreateExtensionRequest:
            this.openRequestExtensionDialog();
            this.dashboardService.getReloadGridDetails(true);
            break;
          case MenuAction.ReviewExtensionRequest:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.evalRowDetails.evaluationSk +
              '/' +
              this.nycId +
              '/review/' +
              this.evaluationDataRoute(this.evalRowDetails),
            ]);
            break;
          case MenuAction.ViewExtensionRequest:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.evalRowDetails.evaluationSk +
              '/' +
              this.nycId +
              '/view/' +
              this.evaluationDataRoute(this.evalRowDetails),
            ]);
            break;
          case MenuAction.ReviewAssessment:
            this.router.navigate([
              this.routesConstantService.routes.evaluations +
              this.referralSk +
              '/' +
              this.evalRowDetails.evaluationSk +
              '/' +
              this.nycId +
              '/reviewassessment/' +
              this.evaluationDataRoute(this.evalRowDetails),
            ]);
            break;
          case MenuAction.SubmitSTAC:
            this.assessmentService
              .updateSTACStatus(this.evalRowDetails.evaluationSk, true)
              .subscribe(() => {
                this.notificationService.show({
                  content: NOTIFICATION_MESSAGES.submitSuccess,
                  cssClass: 'notification-success',
                  hideAfter: dialogTimer,
                  position: { horizontal: 'center', vertical: 'top' },
                  animation: {
                    type: 'slide',
                    duration: dialogAnimationDuration,
                  },
                  type: { style: 'success', icon: true },
                });
                this.dashboardService.getReloadGridDetails(true);
              });
            break;

          case MenuAction.ApproveSTACDocument:
            this.assessmentService
              .updateSTACStatus(this.evalRowDetails.evaluationSk, false)
              .subscribe(() => {
                this.notificationService.show({
                  content: NOTIFICATION_MESSAGES.approveSuccess,
                  cssClass: 'notification-success',
                  hideAfter: dialogTimer,
                  position: { horizontal: 'center', vertical: 'top' },
                  animation: {
                    type: 'slide',
                    duration: dialogAnimationDuration,
                  },
                  type: { style: 'success', icon: true },
                });
                setTimeout(() => {
                  //Added delay to get the latest update on stac submission
                  this.dashboardService.getReloadGridDetails(true);
                }, NAVIGATION_DELAYS);
              });
            break;

          case MenuAction.ScheduleEvaluationMeeting:
            this.isReSchedule.emit(false);
            this.openScheduleMeetingAssessmentDialog();
            this.showDialog = false;
            break;

          case MenuAction.RescheduleEvaluationMeeting:
            this.isReSchedule.emit(true);

            this.meetingSk.emit(this.evalActions.subActionDetails[0].actionSk);
            this.openScheduleMeetingAssessmentDialog();
            this.showDialog = false;
            break;
        }
        break;
      case MenuAction.Student:
        actionObj = this.actionsList.student.stageDetails.find(
          (item: StageActions) =>
            item.actionName.find((text: string) => text === event.item.text)
        );

        actionSk = actionObj.actionSk;

        switch (event.item.text) {
          case MenuAction.Upload:
            this.openUploadDialog();
            break;
          case MenuAction.Reassign:
            this.isReAssign.emit(true);
            this.openReassignDialog();
            break;
          case MenuAction.Assign:
            this.isReAssign.emit(false);
            this.openReassignDialog();
            break;
          case MenuAction.CaseClose:
            this.openCaseClosingEventsDialog();
            break;
          case MenuAction.RequestToSharePersonallyIdentifiableInformation:
            this.router.navigate([
              this.routesConstantService.routes
                .PersonallyIdentifiableInformation +
              this.nycId +
              '/' +
              SHARE_PERSONALLY_IDENTIFIABLE_INFORMATION +
              '/' +
              this.referralSk +
              '/' +
              'add',
            ]);
            break;
          case MenuAction.EditRequestToSharePersonallyIdentifiableInformation:
            this.router.navigate([
              this.routesConstantService.routes
                .PersonallyIdentifiableInformation +
              this.nycId +
              '/' +
              SHARE_PERSONALLY_IDENTIFIABLE_INFORMATION +
              '/' +
              this.referralSk +
              '/' +
              'edit',
            ]);
            break;
          case MenuAction.ViewRequestToSharePersonallyIdentifiableInformation: {
            const index: number =
              this.actionsList.student.stageDetails.findIndex(
                (obj: StageActions) => obj.actionName.includes(event.item.text)
              );
            // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
            let sk: any = SHARE_PERSONALLY_IDENTIFIABLE_INFORMATION;
            if (index > INDEX_NOT_FOUND) {
              sk = this.actionsList.student.stageDetails[index].actionSk;
            }
            this.router.navigate([
              this.routesConstantService.routes
                .PersonallyIdentifiableInformation +
              this.nycId +
              '/' +
              sk +
              '/' +
              this.referralSk +
              '/' +
              'view',
            ]);
            break;
          }
          case MenuAction.CreateEdBenefitReview:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/educational-benefit-review-process/${this.nycId}/${this.iepSk}` +
              '/add',
            ]);
            break;
          case MenuAction.EditEdBenefitReview:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/educational-benefit-review-process/${this.nycId}/${this.iepSk}` +
              '/edit',
            ]);
            break;
          case MenuAction.ViewEdBenefitReview:
            this.router.navigate([
              this.routesConstantService.routes.iepDocumentPage +
              `/educational-benefit-review-process/${this.nycId}/${this.iepSk}` +
              '/view',
            ]);
            break;
          case 'Create Student Exit Summary':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/add/outreach/student-exit-summary',
            ]);
            break;
          case 'Edit Student Exit Summary':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/edit/outreach/student-exit-summary',
            ]);
            break;
          case 'View Student Exit Summary':
            this.router.navigate([
              this.routesConstantService.routes.placement +
              `/${this.iepSk}/${this.nycId}/${this.iepSk}` +
              '/view/outreach/student-exit-summary',
            ]);
            break;
        }
        break;
      case MenuAction.relatedServices:
        actionObj = this.actionsList.relatedService.stageDetails.find(
          (item: StageActions) =>
            item.actionName.find((text: string) => text === event.item.text)
        );
        actionSk = actionObj.actionSk;
        switch (event.item.text) {
          case MenuAction.CreateIEPAcknowledgmentForm:
            this.router.navigate([
              this.routesConstantService.routes.realatedService +
              this.iepSk +
              '/' +
              actionSk +
              '/add',
            ]);
            break;
          case MenuAction.EditIEPAcknowledgmentForm:
            this.router.navigate([
              this.routesConstantService.routes.realatedService +
              this.iepSk +
              '/' +
              actionSk +
              '/edit',
            ]);
            break;
          case MenuAction.ViewIEPAcknowledgmentForm:
            this.router.navigate([
              this.routesConstantService.routes.realatedService +
              this.iepSk +
              '/' +
              actionSk +
              '/view',
            ]);
            break;
          case MenuAction.DeleteIEPAcknowledgmentForm:
            this.router.navigate([
              this.routesConstantService.routes.realatedService +
              this.iepSk +
              '/' +
              actionSk +
              '/delete',
            ]);
            break;
        }
        break;
    }
  }

  openUploadDialog(): void {
    this.uploadDialog.emit(true);
  }

  getPwnUrl(pwnType: number): string {
    let pwnUrl: string = '';
    switch (pwnType) {
      case PwnType.RequestForReEval:
        pwnUrl = PWN_INFO.proposedRequestReevaluation.route;
        break;
      case PwnType.AdditionalReEval:
        pwnUrl = PWN_INFO.requestForAdditionalReevaluation.route;
        break;
      case PwnType.RefusalReEval:
        pwnUrl = PWN_INFO.refusalOfRequestForReevaluation.route;
        break;
      case PwnType.RefusalAdditionalReEval:
        pwnUrl = PWN_INFO.refusalOfRequestForAdditionalReevaluation.route;
        break;
      case PwnType.Mandated3YearReEval:
        pwnUrl = PWN_INFO.mandatedThreeYearReevaluation.route;
        break;
      case PwnType.ParentWaiverMandated3YearReEval:
        pwnUrl = PWN_INFO.parentWaiverMandatedThreeYearReevaluation.route;
        break;
      case PwnType.Initial:
        pwnUrl = PWN_INFO.initial.route;
        break;
      case PwnType.ReevaluationAnnual:
        pwnUrl = PWN_INFO.reevaluationAnnual.route;
        break;
      case PwnType.NoticeOfIR:
        pwnUrl = PWN_INFO.noticeOfIr.route;
        break;
      case PwnType.Refusal:
        pwnUrl = PWN_INFO.refusal.route;
        break;
      case PwnType.PreSchool:
        pwnUrl = PWN_INFO.preSchool.route;
        break;
      case PwnType.ParentallyPlaced:
        pwnUrl = 'parentally-placed';
        break;
      case PwnType.WithdrawalInitialReferralFromSpecialEducationProcess:
        pwnUrl = 'withdrawal';
        break;
    }
    return pwnUrl;
  }

  openScheduleMeetingDialog(): void {
    this.scheduleMeetingDialog.emit(true);
  }

  closeScheduleMeetingDialog(): void {
    this.scheduleMeetingDialog.emit(false);
    this.dashboardService.reloadDashboardSubject$.next(true);
  }

  openScheduleMeetingAssessmentDialog(): void {
    this.scheduleMeetingAssessmentDialog.emit(true);
  }

  closeScheduleMeetingAssessmentDialog(): void {
    this.scheduleMeetingAssessmentDialog.emit(false);
    this.dashboardService.closeActionOnDashboardEvalSubject.next(true);
  }

  openShowCancelMeetingDialog(): void {
    this.cancelMeetingDialog.emit(true);
  }

  closeshowCancelMeetingDialog(): void {
    this.cancelMeetingDialog.emit(false);
  }

  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  openShowCloseRequestForReevaluationDialog(pwnType: any): void {
    this.pwn.emit(pwnType);
    this.closeRequestForReevaluationDialog.emit(true);
  }

  closeShowRequestForReevaluationDialog(): void {
    this.closeRequestForReevaluationDialog.emit(false);
  }

  openRequestExtensionDialog(): void {
    this.requestExtensionDialog.emit(true);
  }

  closeRequestExtensionDialog(): void {
    this.requestExtensionDialog.emit(false);
  }

  afterOnDestroy(): void {
    // afterOnDestroy
    this.closePopup();
  }

  closePopup(): void {
    this.popupRef?.close();
    this.popupRef = null;
  }

  // TODO: Not sure of the datatype. Define and use a proper datatype instead of any
  evaluationDataRoute(data: any): string {
    return get(
      find(ASSESSMENT_INFO, { title: trim(get(data, 'evaluationName')) }),
      'route'
    );
  }
}
